import { Conditions, FeatureFlags, FeatureValue } from '../types';

const checkAuth = (auth: boolean | undefined, isLoggedIn: boolean): boolean =>
  auth === undefined || (!auth && !isLoggedIn) || (auth && isLoggedIn);

const checkFeatureFlags = (
  feature: { [name: string]: FeatureValue } | undefined,
  featureFlags?: FeatureFlags
): boolean =>
  feature === undefined ||
  Object.keys(feature).every(
    (featureName) => featureFlags?.[featureName] === feature?.[featureName]
  );

const matchesCondition = (
  condition: Conditions,
  {
    featureFlags,
    isLoggedIn
  }: {
    featureFlags?: FeatureFlags;
    isLoggedIn?: boolean;
  }
): boolean => {
  const hasAuthState = checkAuth(condition?.auth, Boolean(isLoggedIn));
  const hasFeatureFlag = checkFeatureFlags(condition?.feature, featureFlags);

  return hasAuthState && hasFeatureFlag;
};

export default matchesCondition;
